(() => {
  'use strict';
  function initialize() {
    if (typeof window.initPaginatorComponents !== 'function' || typeof window.refreshPaginatorComponent !== 'function') return;
    if (typeof window.createPointsPagination === 'function') return;
    window.createPointsPagination = (list, strings, onChange, { keepCurrentPage = false } = {}) => {
      strings = { ...JSON.parse(document.querySelector('[data-points-context]').textContent).strings, ...strings };
      const pager = document.querySelector('[data-points-pagination-template]').content.querySelector('nav').cloneNode(true);
      pager.removeAttribute('id');
      pager.setAttribute('data-points-pagination', '');
      pager.hidden = true;
      pager.style.display = 'none';
      pager.style.maxWidth = '100%';
      pager.style.flexWrap = 'wrap';
      pager.setAttribute('aria-label', strings.pagination_label);
      pager.querySelector('[data-prev]').setAttribute('aria-label', strings.pagination_previous);
      pager.querySelector('[data-next]').setAttribute('aria-label', strings.pagination_next);
      list.after(pager);
      window.initPaginatorComponents();
      let current = 1;
      let loadingTimer;
      const spinner = document.createElement('span');
      spinner.className = 'points-pagination__spinner';
      spinner.setAttribute('aria-hidden', 'true');
      pager.append(spinner);
      if (keepCurrentPage) pager.classList.add('points-pagination--quiet');
      pager.addEventListener('paginator:change', event => {
        const requested = event.detail.current;
        if (keepCurrentPage) {
          pager.dataset.current = String(current);
          window.refreshPaginatorComponent(pager);
        } else current = requested;
        onChange(requested);
      });
      return {
        reset() { current = 1; },
        setBusy(busy, { delayedIndicator = false } = {}) {
          clearTimeout(loadingTimer);
          pager.classList.remove('is-loading');
          if (busy && delayedIndicator) {
            loadingTimer = setTimeout(() => pager.classList.add('is-loading'), 350);
          }
          pager.inert = busy;
          pager.setAttribute('aria-busy', String(busy));
        },
        update(page, pages, count) {
          current = page;
          const hasCount = Number.isSafeInteger(count) && count >= 0;
          const total = Math.max(1, hasCount ? Math.ceil(count / 5) : pages);
          Object.assign(pager.dataset, { current: String(current), count: hasCount ? String(count) : '0', total: String(total) });
          pager.hidden = total <= 1;
          pager.style.display = total <= 1 ? 'none' : 'inline-flex';
          window.refreshPaginatorComponent(pager);
        }
      };
    };
    document.dispatchEvent(new CustomEvent('points:pagination-ready'));
  }
  document.addEventListener('paginator:ready', initialize);
  initialize();
})();
